let checkRequiredParams = Symbol.for('checkRequiredParams')
const filesValidateMixinParentActions = {
  methods: {
    [Symbol.keyFor(checkRequiredParams)](refs) {
      return (
        this.$canAction('load_files_not_required') ||
        !Array.isArray(refs) ||
        !Object.keys(refs).length
      )
    },
    checkCountFilesBeforeSave(refs) {
      if (this[Symbol.keyFor(checkRequiredParams)](refs)) {
        return true
      }
      let successLoadFiles = {
        state: true,
        messages: [],
      }

      Array.prototype.forEach.call(
        refs,
        function(refName) {
          let ref = this.$refs[refName]

          if (typeof ref !== typeof void 0) {
            let filesState = ref.countedFiles()

            if (!filesState.value) {
              successLoadFiles.state = false
              successLoadFiles.messages.push(filesState.errorMessage)
            }
          }
        },
        this,
      )

      if (!successLoadFiles.state) {
        let errorMessage = `Загрузите файлы: ${successLoadFiles.messages.join(
          ', ',
        )}`
        let config = this.isMobile
          ? { center: true, customClass: 'message-files-alert' }
          : {}

        this.$alert(errorMessage, config)
      }

      return successLoadFiles.state
    },
  },
}

const filesValidateMixinChildActions = {
  methods: {
    countedFiles() {
      let { errorMessage, refComponentName, childFilesCountProperty } =
        this.filesValidateMixinData

      return {
        value: Boolean(this.$refs[refComponentName][childFilesCountProperty]),
        errorMessage,
      }
    },
    checkCountFilesBeforeSaveInOwn() {
      let filesState = this.countedFiles()

      if (!filesState.value) {
        let errorMessage = `Загрузите файлы: ${filesState.errorMessage}`
        let config = this.isMobile
          ? { center: true, customClass: 'message-files-alert' }
          : {}

        this.$alert(errorMessage, config)

        return false
      }

      return true
    },
  },
}

export { filesValidateMixinParentActions, filesValidateMixinChildActions }
